import { toTitleCase } from '@/react/common/string-utils';

import { Badge } from '@@/Badge';

import { TRIVY_SEVERITIES, severityRank } from '../../types';
import { VulnerabilityRow } from '../types';
import { severityBadgeType } from '../../severityDisplay';

import { columnHelper } from './helper';

/**
 * Sorts on the most severe finding present.
 *
 * Filtering by severity lives on the Findings column, which holds the per
 * severity counts it matches against.
 */
export const severity = columnHelper.accessor('highestSeverity', {
  header: 'Highest severity',
  id: 'severity',
  cell: ({ row: { original: row } }) =>
    row.highestSeverity ? (
      <Badge type={severityBadgeType(row.highestSeverity)}>
        {toTitleCase(row.highestSeverity)}
      </Badge>
    ) : (
      <Badge type="success">Clean</Badge>
    ),
  sortingFn: (a, b) => rank(a.original) - rank(b.original),
});

function rank(row: VulnerabilityRow): number {
  return row.highestSeverity
    ? severityRank(row.highestSeverity)
    : TRIVY_SEVERITIES.length;
}
